
// import { RouteObject } from 'react-router-dom';
import type { RouteObject } from "react-router";
import { lazy } from 'react';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const New = lazy(() => import('../pages/new/page'));
const Upload = lazy(() => import('../pages/upload/page'));
const Review = lazy(() => import('../pages/review/page'));
const Report = lazy(() => import('../pages/report/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/new',
    element: <New />,
  },
  {
    path: '/upload',
    element: (
      <ProtectedRoute>
        <Upload />
      </ProtectedRoute>
    ),
  },
  {
    path: '/review',
    element: (
      <ProtectedRoute>
        <Review />
      </ProtectedRoute>
    ),
  },
  {
    path: '/report',
    element: (
      <ProtectedRoute>
        <Report />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
